import { Heading, Box, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import Polygon from '@public/images/achievementPolygon.svg'

export const StyledPolygon = styled(Polygon)`
  position: absolute;
  right: 0;
  top: 113px;
`

export const Wrapper = styled(Box)`
  position: relative;
`

export const ImageWrapper = styled(Box)`
  height: 56px;

  img {
    object-fit: contain;
  }

  ${({ theme }) => theme.below.laptop`
    align-self: center;
  `}
`

export const ContentBox = styled(Box)`
  flex-direction: row;
  flex-wrap: wrap;
  z-index: 1;

  ${({ theme }) => css`
    div:nth-child(odd) {
      svg {
        fill: ${theme.newColors.orange};
      }
    }

    div:nth-child(even) {
      svg {
        fill: rgb(139, 143, 159);
      }
    }

    ${theme.below.laptop`
      justify-content: center;
    `}

    ${theme.below.laptopL`
      justify-content: space-between;
    `}
  `}
`

export const Container = styled(Box)`
  box-shadow: none;
  display: flex;
  flex-direction: column;
  width: 253px;

  ${({ theme }) => css`
    &:not(:last-child) {
      margin-bottom: 0;
    }

    ${theme.below.laptopL`
      &:nth-child(1),
      &:nth-child(4) {
        position: relative;
        right: 0;
      }

      &:nth-child(3),
      &:nth-child(6) {
        position: relative;
        left: 0;
      }
    `}
  `}
`

export const TableTitle = styled(Heading)`
  align-self: flex-start;
  line-height: 56px;
  text-decoration: none;
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.newColors.accent};
    font-size: ${theme.fontSizes[6]}px;
    font-weight: ${theme.fontWeight[7]};

    ${theme.below.laptop`
      align-self: center;
    `}
  `}
`

export const TableSubtitle = styled(Paragraph)`
  ${({ theme }) => css`
    color: ${theme.newColors.darkGray};
    font-size: ${theme.fontSizes[17]}px;
    font-weight: ${theme.fontWeight[2]};
    margin-top: ${theme.newSpaces.xs}px;
    white-space: pre-wrap;

    ${theme.below.laptopL`
      ${theme.getTypography('mobile', 'body', 'body1')};
    `}

    ${theme.below.laptop`
      text-align: center;
    `}

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body2')};
    `}
  `}
`
export const LottieWrapper = styled.div`
  position: relative;

  & > div {
    margin: 0;
  }

  svg {
    height: 111px;
    width: 111px;
  }
`
